const FirestoreCollection = {
    QUOTATIONS: 'Quotations',
    SERVICES: 'Services',
    INVOICES: 'Invoices',
    ELEMENTS: 'Elements',
    USERS: 'Users',
    CHECKS: 'Checks'
};

module.exports = FirestoreCollection;